import React from 'react';

const LinkedInPosts = () => {
  // LinkedIn posts data - Add post details manually for reliable previews
  // LinkedIn blocks most link preview APIs, so manual entry is more reliable
  const posts = [
    {
      url: 'https://www.linkedin.com/posts/sudeept-selot-5535a1a_technology-is-easy-culture-to-adopt-is-hard-activity-7425033067188248576-O8uD',
      title: 'Technology is easy, culture to adopt is hard.',
      description: 'The "AI and Culture Dialogue" in Mumbai, at Jio World Centre revealed key insights: AI success depends on organizational readiness, psychological safety matters, and AI amplifies existing culture.',
      image: '',
      author: 'Sudeept Selot',
      date: '2 weeks ago'
    },
    {
      url: 'https://www.linkedin.com/posts/deepak-malkani_ai-organisationculture-activity-7423964337406500864-oZMB',
      title: 'AI & Organisational Culture: A Roundtable Discussion at MIT',
      description: 'Both AI and Organisational Culture studies emerged at MIT decades apart. Insights from the Culture Dialogue roundtable: successful AI adoption won\'t happen without a culture of trust that rewards experimentation over perfection.',
      image: '',
      author: 'Deepak Malkani',
      date: '2 weeks ago'
    },
    {
      url: 'https://www.linkedin.com/posts/ravi-doshi-90a740136_ai-adoption-is-easy-culture-readiness-is-activity-7423672062608703488-PY4V',
      title: 'AI adoption is easy. Culture readiness is the real bottleneck.',
      description: 'Sharing insights from the Culture Dialogue event on AI and organizational culture.',
      image: '',
      author: 'Ravi Doshi',
      date: '2 weeks ago'
    },
    {
      url: 'https://www.linkedin.com/posts/priya-mirchandani-28176748_culturedialogue-leadership-cultureandai-activity-7408793387287531520-18FV',
      title: 'Conversation means gaining experience, not simply sharing',
      description: 'An eye opener on how industries are perceiving AI transformation and how organizational culture is shaping differently. Change is happening at a faster pace and organizations challenges are becoming unique.',
      image: '',
      author: 'Priya Mirchandani',
      date: '2 months ago'
    },
    {
      url: 'https://www.linkedin.com/posts/activity-7422946085620305920-4OTR',
      title: 'Culture Dialogue: AI and Culture',
      description: 'Insights from the Culture Dialogue roundtable discussion.',
      image: '',
      author: 'LinkedIn User',
      date: '2 weeks ago'
    },
    {
      url: 'https://www.linkedin.com/posts/ravibhushanpandav_hrleadership-cultureinai-remotework-activity-7411128969162428416-8TY1',
      title: 'HR Leadership, Culture in AI, Remote Work',
      description: 'Thoughts on HR leadership and culture in the age of AI.',
      image: '',
      author: 'Ravi Bhushan Pandav',
      date: '1 month ago'
    },
    {
      url: 'https://www.linkedin.com/posts/subuks_ai-and-its-influence-on-organizational-culture-activity-7406162337285595136-_jy3',
      title: 'AI and its influence on organizational culture',
      description: 'Exploring how AI influences organizational culture and leadership.',
      image: '',
      author: 'Subuks',
      date: '1 month ago'
    },
    {
      url: 'https://www.linkedin.com/posts/lopamudrapriyadarshini_culturedialogue-aishame-inclusion-ugcPost-7406903456357179392-0iaZ',
      title: 'Culture Dialogue: AI, Shame, and Inclusion',
      description: 'Reflections on Culture Dialogue focusing on AI, inclusion, and organizational culture.',
      image: '',
      author: 'Lopamudra Priyadarshini',
      date: '1 month ago'
    }
  ];

  if (posts.length === 0) {
    return null; // Don't show section if no posts
  }

  return (
    <section className="py-[100px] bg-white opacity-0 animate-fadeIn-delayed-5">
      <div className="w-[90%] max-w-[1200px] mx-auto px-5">
        <h2 className="font-heading font-semibold text-[2rem] relative pb-[15px] mb-4 text-[#333333] text-center">
          What Participants Are Saying
        </h2>
        <p className="max-w-[700px] mx-auto mb-12 text-center text-base text-[#666666]">
          Read what participants are sharing about their Culture Dialogue experience
        </p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5 mt-[50px]">
          {posts.map((post, index) => (
            <a
              key={index}
              href={post.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative overflow-hidden bg-[linear-gradient(135deg,#ffffff_0%,#f8f9fa_100%)] border-2 border-[rgba(0,0,0,0.1)] rounded-xl shadow-[0_4px_20px_rgba(0,0,0,0.08)] transition-all duration-300 before:content-[''] before:absolute before:top-0 before:left-0 before:right-0 before:h-1 before:bg-gradient-to-r before:from-[#0077b5] before:to-[#6B4DC4] before:opacity-0 before:transition-all before:duration-300 hover:before:opacity-100 hover:-translate-y-[5px] hover:shadow-[0_10px_30px_rgba(107,77,196,0.25)] hover:border-[#6B4DC4]"
            >
              {/* LinkedIn Header */}
              <div className="px-4 pt-4 pb-3 border-b border-[rgba(0,0,0,0.05)]">
                <div className="flex items-center justify-between">
                  <div className="flex items-center">
                    <div className="w-8 h-8 bg-gradient-to-br from-[#0077b5] to-[#005885] rounded-full flex items-center justify-center mr-2 shadow-[0_2px_8px_rgba(0,119,181,0.3)]">
                      <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 24 24">
                        <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
                      </svg>
                    </div>
                    <div>
                      <div className="font-heading font-semibold text-xs text-[#333333] leading-tight">{post.author || 'LinkedIn'}</div>
                      {post.date && (
                        <div className="text-[10px] text-[#999999] mt-0.5">{post.date}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              
              {/* Content */}
              <div className="p-4">
                {/* Title */}
                <h3 className="font-heading font-semibold text-sm text-[#333333] mb-2 line-clamp-2 leading-snug group-hover:text-[#6B4DC4] transition-colors duration-300">
                  {post.title}
                </h3>
                
                {/* Description */}
                {post.description && (
                  <p className="text-xs text-[#666666] mb-3 line-clamp-3 leading-relaxed">
                    {post.description}
                  </p>
                )}
                
                {/* Read More Link */}
                <div className="flex items-center text-[#0077b5] font-medium text-xs group-hover:text-[#6B4DC4] transition-colors duration-300">
                  <span>Read on LinkedIn</span>
                  <svg className="w-3 h-3 ml-1.5 transform group-hover:translate-x-1 transition-transform duration-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                  </svg>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LinkedInPosts;
